'use strict';

define('GTMMod',[
    'angular',
    'angularRoute',
    'GTMFac',
    'ScreenNames',
    'SectionNames',
    'TVGCommon',
    'RaceInfo'
], function (
    angular,
    ngRoute,
    GTMFac,
    ScreenNames,
    SectionNames,
    TVGCommon,
    RaceInfo
) {
    return angular
        .module('TVG.Common.GTM', ['ngRoute', TVGCommon.default, RaceInfo])
        .factory('GTMFac', GTMFac)
        .constant('ScreenNames', ScreenNames)
        .constant('SectionNames', SectionNames)
        .name;
});

